import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from 'projects/my/src/app.settings';
import { CustomerKbaAnswerData, CustomerKbaConversation } from 'common';

@Injectable({
  providedIn: 'root'
})
export class CustomerKbaService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient,
    private settings: AppSettings) {
    this.baseUrl = `${this.settings.customers.url}/api/checkout`;
  }

  answer(form: any): Observable<CustomerKbaAnswerData> {
    return this.http.post<CustomerKbaAnswerData>(`${this.baseUrl}/idology`, form);
  }

  getQuestions(): Observable<CustomerKbaConversation> {
    return this.http.get<CustomerKbaConversation>(`${this.baseUrl}/idology`);
  }
}
